import { useAccount } from 'wagmi';
import { GetAccountResult } from '@wagmi/core';

export type UseAccountConfig = {
  /** Function to invoke when connected */
  onConnect?({
    address,
    connector,
    isReconnected,
  }: {
    address?: GetAccountResult['address'];
    connector?: GetAccountResult['connector'];
    isReconnected: boolean;
  }): void;
  /** Function to invoke when disconnected */
  onDisconnect?(): void;
};

export function useAccountLowercase(config?: UseAccountConfig) {
  const { address, ...result } = useAccount(config);
  const addressLowercase = address?.toLowerCase() as `0x${string}` | undefined;
  return { address: addressLowercase, ...result };
}
